/* IBO custom (see theme/CUSTOMIZATIONS.md). "Free Pistachio Delight" cart auto-add, task 238 (2026-10-14).
   Based on the Opening Treat script (git tree cb66c914, assets/ibo-opening-treat.js) with new keys.
   Config comes from #ibo-gift-config (snippets/ibo-gift.liquid, rendered by sections/ibo-free-shipping-bar.liquid
   while the section setting "gift_enabled" is on, also outside the window and at sell-out, so this script can
   clean up gift lines).

   Rules
   - Qualifying subtotal = the basis of Shopify's Buy X get Y "minimum purchase amount": product lines at FULL
     price (original_line_price, before any discount; order codes like WELCOME10 do not lower it), before
     shipping and tax, without the gift line, any line of the gift variant, the excluded handles (gift
     packaging) and any line that already has another product discount.
   - Inside the start/end window, gift available, qualifying >= minimum: add ONE gift line (gift variant with the
     hidden line property _ibo_gift). Never more than one: extra gift lines are removed; a raised gift quantity
     goes back to 1 and the extra units are added as a normal (paid) line.
   - Qualifying < minimum, or outside the window: every gift line is removed.
   - Not available (config "available" false, or a cart/add stock error 422, or the preview test param
     ibo_gift_soldout=1): nothing is added and every gift line is removed.
   - The customer removed the gift while still qualifying ("removed" state): it is not added again in this tab
     until the qualifying subtotal first drops below the minimum and reaches it again, or a new cart starts.
   - The gift variant added by the customer (no property): no gift line is added; the automatic discount makes
     one unit free ("own" state).
   - requireFree (default on): a gift line that is not free is removed, and the script waits 10 minutes before it
     tries again, so nobody pays for it. Checked right after an add and on every run.
   - v2 (2026-10-15): Shopify can split the gift into a charged line and a $0 line (also after a double add).
     The script keeps the gift line with the lowest final_line_price, removes the others, and only then runs
     the not-free check on the kept line. failClosed() re-checks after every change. One add request at a
     time (in-tab flag plus a 15 s localStorage lock "ibo_gift_adding" across tabs).
   - v3 (2026-10-21, task 493, /cart page ONLY; PDP, quick add, drawer and remove paths unchanged):
     1. First visit: the script runs after /cart.js resolves. If the gift is due but missing, or the run failed
        (network or cart error), it runs ONE more time 800 ms later.
     2. On /cart, a cross-tab add lock older than 3 s counts as stale (the page that set it was left before
        its add finished; the add has landed or failed by then). Before, /cart waited up to 15 s.
     3. Checkout button guard: a click (form submit with name "checkout") waits for the gift check (max 8 s;
        it checks again every 700 ms while the gift is due and missing). If the gift is due, it is added first. If this page changed the cart, the shopper goes to
        /checkout directly (the cart form's updates[] fields follow the old line order, so the form is not
        posted); otherwise the form is submitted as before.
   - Window: blank start = no start limit. Blank, invalid or offset-less end or start = offer off (fail closed).
   The $0 price itself comes only from the Shopify automatic discount "Free Pistachio Delight $100+".

   Progress line (snippets/ibo-gift-progress.liquid): states away / unlocked / removed / own (off = hidden).
   window.iboGiftPaint (inline in snippets/ibo-gift.liquid) paints it from window.iboGiftSSR at first render;
   this script updates iboGiftSSR after each run and repaints every [data-ibo-gift-progress] element,
   also after Canopy re-renders the drawer or cart.

   Triggers: page load, Canopy cart events, and any fetch() to /cart/add|change|update|clear. The script's own
   requests carry ibo_gift=1 and are ignored here and by the "Added to cart" toast in ibo-free-shipping.js.

   QA test mode, PREVIEW THEMES ONLY (never while Shopify.theme.role is "main"):
     ?ibo_gift_test=1      status panel + console log ([ibo-gift]); real rules, incl. requireFree
     ?ibo_gift_test=keep   same, but a gift that is not $0 is KEPT (do not check out)
     ?ibo_gift_test=0      test mode off
     &ibo_gift_now=2026-10-20T10:00:00-04:00  (with test mode) simulate the clock; ibo_gift_now=0 clears it
     &ibo_gift_soldout=1   (with test mode) treat the gift as not available; ibo_gift_soldout=0 clears it
   Choices are kept for the browser tab (sessionStorage). */
(() => {
  const d = document;
  const cfgEl = d.getElementById('ibo-gift-config');
  if (!cfgEl || window.iboGift || (window.Shopify && window.Shopify.designMode)) return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  const VID = Number(cfg.variantId);
  const MIN = Number(cfg.min);
  if (!VID || !(MIN > 0)) return;

  const PROP = '_ibo_gift';
  const MARK = 'ibo_gift=1';
  const STORE_KEY = 'ibo_gift';
  const RETRY_MS = 10 * 60 * 1000;
  const base = String(cfg.root || '/').replace(/\/$/, '');
  const url = (p) => `${base}/${p}?${MARK}`;
  const exclude = String(cfg.exclude || '').split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);
  const qs = new URLSearchParams(window.location.search);
  const onCartPage = () => window.location.pathname.replace(/\/$/, '') === String(cfg.cartUrl || '/cart').replace(/\/$/, '');
  const CART_PAGE = onCartPage();

  // QA test mode: only on a theme whose role is known and is not "main".
  const TEST = (() => {
    const role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
    if (!role || role === 'main') return '';
    const KEY = 'ibo_gift_test';
    try {
      const p = qs.get(KEY);
      if (p === '0') sessionStorage.removeItem(KEY);
      else if (p === '1' || p === 'keep') sessionStorage.setItem(KEY, p);
      return sessionStorage.getItem(KEY) || '';
    } catch (e) { return ''; }
  })();
  const testParam = (KEY, valid) => {
    if (!TEST) return '';
    try {
      const p = qs.get(KEY);
      if (p === '0' || qs.get('ibo_gift_test') === '0') sessionStorage.removeItem(KEY);
      else if (p && valid(p)) sessionStorage.setItem(KEY, p);
      return sessionStorage.getItem(KEY) || '';
    } catch (e) { return ''; }
  };
  const requireFree = !!cfg.requireFree && TEST !== 'keep';
  const TEST_NOW = Date.parse(testParam('ibo_gift_now', (p) => !Number.isNaN(Date.parse(p))) || '');
  const TEST_SOLDOUT = testParam('ibo_gift_soldout', (p) => p === '1') === '1';
  const AVAILABLE = cfg.available !== false && !TEST_SOLDOUT;
  const loadedAt = Date.now();
  const clock = () => (Number.isNaN(TEST_NOW) ? Date.now() : TEST_NOW + (Date.now() - loadedAt));
  let lastAction = 'none yet';
  const note = (msg) => { lastAction = msg; if (TEST) console.info('[ibo-gift]', msg); };
  const usd = (c) => `$${(c / 100).toFixed(2)}`;

  // ISO 8601 with an offset only; anything else is NaN (fail closed).
  const ISO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(\.\d+)?(Z|[+-]\d{2}:\d{2})$/;
  const parseIso = (s) => (ISO.test(String(s).trim()) ? Date.parse(String(s).trim()) : NaN);
  const tStart = cfg.start ? parseIso(cfg.start) : -Infinity;
  const tEnd = cfg.end ? parseIso(cfg.end) : NaN;
  const inWindow = () => {
    const now = clock();
    return !Number.isNaN(tStart) && !Number.isNaN(tEnd) && now >= tStart && now <= tEnd;
  };

  const isGift = (i) => !!(i.properties && i.properties[PROP]);
  const productDiscounted = (i) => (i.line_level_discount_allocations || []).some((a) => a.amount > 0);
  const qualifying = (cart) => cart.items.reduce((sum, i) => (
    isGift(i) || i.variant_id === VID || exclude.includes(String(i.handle).toLowerCase()) || productDiscounted(i)
      ? sum : sum + i.original_line_price
  ), 0);

  const load = () => { try { return JSON.parse(sessionStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; } };
  const save = (s) => { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) { /* private mode */ } };

  const json = (r) => r.json().catch(() => ({})).then((j) => (r.ok ? j : Promise.reject({ status: r.status, body: j })));
  const getCart = () => fetch(url('cart.js'), { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(json);
  const post = (p, body) => fetch(url(p), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  }).then(json);

  // Progress line: publish the state and repaint every progress element.
  const paintAll = () => {
    if (typeof window.iboGiftPaint !== 'function') return;
    d.querySelectorAll('[data-ibo-gift-progress]').forEach((el) => window.iboGiftPaint(el));
  };
  const publish = (state, left) => {
    window.iboGiftSSR = Object.assign({}, window.iboGiftSSR, { state, left: left || 0, live: true });
    paintAll();
  };

  let changed = false;
  let lastCount = null;
  let lastNeed = false; // v3: set by evaluate()
  let lastErr = false; // v3: the last run threw (network or cart error)
  let pageMutated = false; // v3: this script changed the cart on this page

  // v2 (2026-10-15) fail-closed check after any gift change: keep at most ONE gift line (the cheapest) and
  // remove it too if it is charged (requireFree). Returns { cart, charged } (charged = a removed charged line).
  const failClosed = async (cart, st) => {
    const left = cart.items.filter(isGift);
    if (!left.length) return { cart, charged: null };
    const keep = left.reduce((a, g) => (g.final_line_price < a.final_line_price ? g : a));
    const charged = requireFree && keep.final_line_price > 0 ? keep : null;
    const bad = left.filter((g) => g !== keep || charged);
    if (!bad.length) return { cart, charged: null };
    const updates = {};
    bad.forEach((g) => { updates[g.key] = 0; });
    const next = await post('cart/update.js', { updates });
    changed = true;
    if (charged) st.retryAt = Date.now() + RETRY_MS;
    return { cart: next, charged };
  };

  // v2 (2026-10-15): one gift add request at a time, also across tabs (localStorage lock, 15 s).
  const LOCK_KEY = 'ibo_gift_adding';
  const LOCK_MS = 15000;
  // v3: on /cart a lock older than 3 s is stale (its page was left mid-add; that add has landed or failed).
  const LOCK_CART_MS = 3000;
  let adding = false;
  const takeLock = () => {
    if (adding) return false;
    try {
      const t = Number(localStorage.getItem(LOCK_KEY)) || 0;
      if (t && Date.now() - t < (CART_PAGE ? LOCK_CART_MS : LOCK_MS)) return false;
      localStorage.setItem(LOCK_KEY, String(Date.now()));
    } catch (e) { /* private mode: the in-tab flag still works */ }
    adding = true;
    return true;
  };
  const dropLock = () => {
    adding = false;
    try { localStorage.removeItem(LOCK_KEY); } catch (e) { /* ignore */ }
  };

  const evaluate = async () => {
    let cart = await getCart();
    if (cfg.currency && cart.currency && cart.currency !== cfg.currency) { publish('off'); return; }

    let st = load();
    if (st.token !== cart.token) st = { token: cart.token };
    const gifts = cart.items.filter(isGift);
    const q = qualifying(cart);
    const active = inWindow();
    const available = AVAILABLE && !st.na;

    // The gift was there at our last look and the customer took it out while still qualifying.
    if (st.had && !gifts.length && q >= MIN) st.declined = true;
    // Below the minimum: a later crossing counts as a new, real change.
    if (q < MIN) st.declined = false;

    const updates = {};
    let extraPaid = 0;
    let notFree = null;
    if (!active || !available || q < MIN) {
      gifts.forEach((g) => { updates[g.key] = 0; });
    } else {
      // v2 (2026-10-15): Shopify can split one gift line into a charged line and a $0 line (also after a
      // duplicate add). Keep the gift line with the LOWEST final_line_price; remove the other gift lines.
      const own = gifts.filter((g) => g.variant_id === VID);
      const keep = own.reduce((a, g) => (!a || g.final_line_price < a.final_line_price ? g : a), null);
      own.forEach((g) => { if (g !== keep) updates[g.key] = 0; });
      gifts.filter((g) => g.variant_id !== VID).forEach((g) => { updates[g.key] = 0; });
      if (keep && keep.quantity > 1) {
        extraPaid = keep.quantity - 1;
        updates[keep.key] = 1;
      }
      // Only now: is the kept gift line free (one unit's price taken off)? If not, remove it (fail closed).
      if (keep && requireFree && keep.final_line_price > (keep.quantity - 1) * keep.original_price) {
        updates[keep.key] = 0;
        st.retryAt = Date.now() + RETRY_MS;
        notFree = keep;
      }
    }
    if (Object.keys(updates).length) {
      cart = await post('cart/update.js', { updates });
      changed = true;
      const fc = await failClosed(cart, st);
      cart = fc.cart;
      if (fc.charged && !notFree) notFree = fc.charged;
      note(!active ? 'outside the offer window: gift removed'
        : !available ? 'gift not available: gift lines removed'
        : q < MIN ? `below ${usd(MIN)} (${usd(q)}): gift removed`
        : notFree ? `gift in cart not free (${usd(notFree.final_line_price)}): removed, retry in 10 min`
        : extraPaid ? `gift quantity set back to 1 (${extraPaid} moved to a paid line)` : 'extra gift line removed');
    }
    if (extraPaid) {
      await post('cart/add.js', { items: [{ id: VID, quantity: extraPaid }] });
      changed = true;
      cart = await getCart();
      // The new paid line can take the discount away from the gift line: check again (fail closed).
      const fc = await failClosed(cart, st);
      cart = fc.cart;
      if (fc.charged) note(`gift line charged after the paid line was added (${usd(fc.charged.final_line_price)}): removed, retry in 10 min`);
    }

    const ownGift = () => cart.items.some((i) => i.variant_id === VID && !isGift(i));
    if (active && available && q >= MIN && !cart.items.some(isGift) && !st.declined) {
      const waiting = st.retryAt && Date.now() < st.retryAt;
      if (!ownGift() && !waiting && !takeLock()) {
        // Another add is in flight (this tab or another tab): look again when it is done.
        note('another gift add is in progress: check again shortly');
        schedule(CART_PAGE ? 1000 : LOCK_MS / 3);
      } else if (!ownGift() && !waiting) {
        try {
          // Re-read the cart inside the lock: another tab can have added the gift a moment ago.
          cart = await getCart();
          if (!cart.items.some(isGift)) {
            await post('cart/add.js', { items: [{ id: VID, quantity: 1, properties: { [PROP]: '1' } }] });
            changed = true;
            cart = await getCart();
          }
          // Split or duplicate gift lines, or a charged gift: keep one $0 line at most (fail closed).
          const fc = await failClosed(cart, st);
          cart = fc.cart;
          const g = cart.items.find(isGift);
          if (fc.charged) {
            note(`gift added but not free (${usd(fc.charged.final_line_price)}): removed again, retry in 10 min`);
          } else {
            delete st.retryAt;
            note(g ? `gift added (${usd(g.final_line_price)})` : 'gift add returned no gift line');
          }
        } catch (e) {
          if (e && e.status === 422) {
            st.na = true; // stock error: sold out for this cart, stop trying
            note('gift add failed with a stock error (422): not available, no more tries for this cart');
          } else {
            st.retryAt = Date.now() + RETRY_MS;
            note('gift add failed: retry in 10 min');
          }
        } finally {
          dropLock();
        }
      } else if (!notFree) {
        note(ownGift() ? 'own gift variant in cart: no gift line added' : 'waiting for the 10-minute retry');
      }
    } else if (active && available && q >= MIN && st.declined && !cart.items.some(isGift)) {
      note('customer removed the gift: not re-added until below the minimum and back');
    }

    st.had = cart.items.some(isGift);
    save(st);
    lastCount = cart.item_count;

    // Progress state (same basis as the add rule).
    const q2 = qualifying(cart);
    const nonGift = cart.items.some((i) => !isGift(i));
    let state = 'off';
    if (active && available && !st.na && nonGift) {
      if (q2 < MIN) state = 'away';
      else if (st.had) state = 'unlocked';
      else if (ownGift()) state = 'own';
      else if (st.declined) state = 'removed';
    }
    publish(state, MIN - q2);
    // v3: the gift is due but not in the cart (not removed by the customer, no own gift, no 10-minute wait).
    lastNeed = active && available && !st.na && q2 >= MIN && !st.had && !st.declined && !ownGift()
      && !(st.retryAt && Date.now() < st.retryAt);

    if (TEST) {
      if (!changed && !gifts.length && (!active || q < MIN)) note(!active ? 'outside the offer window: no gift' : `below ${usd(MIN)}: no gift`);
      panel(cart, q2, active, available && !st.na, st, state);
    }
  };

  // QA test panel (test mode only).
  let box;
  let lastArgs;
  const panel = (cart, q, active, available, st, state) => {
    lastArgs = [cart, q, active, available, st, state];
    if (!box) {
      box = d.createElement('div');
      box.id = 'ibo-gift-test';
      box.setAttribute('style', 'position:fixed;left:8px;bottom:72px;z-index:2147483000;max-width:min(300px,calc(100vw - 16px));'
        + 'background:#111;color:#fff;font:12px/1.4 system-ui,sans-serif;padding:8px 10px;border-radius:6px;opacity:.92;box-shadow:0 2px 8px rgba(0,0,0,.3)');
      box.addEventListener('click', (e) => {
        const a = e.target.getAttribute('data-gift');
        if (a === 'run') run();
        if (a === 'reset') { try { sessionStorage.removeItem(STORE_KEY); } catch (err) { /* ignore */ } note('state reset'); run(); }
        if (a === 'hide') {
          try { sessionStorage.setItem('ibo_gift_test_min', sessionStorage.getItem('ibo_gift_test_min') ? '' : '1'); } catch (err) { /* ignore */ }
          panel(...lastArgs);
        }
      });
      d.body.appendChild(box);
    }
    const g = cart.items.find(isGift);
    const rows = [
      `<b>Free Pistachio Delight test</b> (${TEST === 'keep' ? 'keep: gift kept even if not $0' : 'real rules'})`,
      `Window: ${active ? 'open' : 'CLOSED'} · Available: ${available ? 'yes' : 'NO'}${TEST_SOLDOUT ? ' (soldout test)' : ''}`,
      `Qualifying: ${usd(q)} / min ${usd(MIN)} · Progress: ${state}`
        + (Number.isNaN(TEST_NOW) ? '' : `<br>Simulated clock: ${new Date(clock()).toLocaleString()}`),
      `Gift line: ${g ? `yes, qty ${g.quantity}, ${usd(g.final_line_price)}` : 'no'}`,
      `Removed by customer: ${st.declined ? 'yes' : 'no'}${st.retryAt ? ` · Retry after ${new Date(st.retryAt).toLocaleTimeString()}` : ''}`,
      `Last: ${lastAction}`
    ];
    const btn = (a, t) => `<button type="button" data-gift="${a}" style="margin:6px 6px 0 0;padding:2px 8px;font:inherit;color:#111;background:#fff;border:0;border-radius:4px;cursor:pointer">${t}</button>`;
    let min = false;
    try { min = !!sessionStorage.getItem('ibo_gift_test_min'); } catch (e) { /* ignore */ }
    box.style.padding = min ? '2px' : '8px 10px';
    box.innerHTML = min
      ? btn('hide', `Gift test: gift ${g ? 'yes' : 'no'} (show)`).replace('margin:6px 6px 0 0', 'margin:0')
      : `${rows.join('<br>')}<br>${btn('run', 'Run now')}${btn('reset', 'Reset')}${btn('hide', 'Hide')}`;
  };

  // Re-render Canopy's cart UI after our own changes.
  let lateT;
  const refreshUI = () => {
    const onCartPage = window.location.pathname.replace(/\/$/, '') === String(cfg.cartUrl || '/cart').replace(/\/$/, '');
    if (onCartPage) {
      const items = d.querySelector('cart-items');
      if (items && items.dataset.empty === 'false' && items.fetchRequestOpts && typeof items.refreshCartItems === 'function') {
        items.refreshCartItems();
      } else {
        window.location.reload();
      }
      return;
    }
    const drawer = d.querySelector('cart-drawer');
    if (!drawer || typeof drawer.refreshCartDrawer !== 'function') return;
    const go = () => {
      const items = drawer.querySelector('cart-items');
      // Partial refresh only works for a cart-items element that initialised with items.
      drawer.refreshCartDrawer(!(items && items.cartDrawer));
      // Canopy's partial refresh leaves the drawer heading "Products (N)" as it was.
      const count = d.getElementById('cart-drawer__count');
      if (count && typeof lastCount === 'number') count.textContent = `(${lastCount})`;
    };
    go();
    clearTimeout(lateT);
    lateT = setTimeout(go, 900);
  };

  let running = false;
  let again = false;
  let runP = Promise.resolve();
  // v3: run() returns a promise that resolves when the current run loop (including queued re-runs) ends.
  const run = () => {
    if (running) { again = true; return runP; }
    running = true;
    runP = (async () => {
      do {
        again = false;
        lastErr = false;
        try { await evaluate(); } catch (e) { lastErr = true; /* network or cart error: try again on the next change */ }
      } while (again);
      running = false;
      if (changed) {
        changed = false;
        pageMutated = true;
        refreshUI();
      }
    })();
    return runP;
  };
  const sleep = (ms) => new Promise((r) => { setTimeout(r, ms); });
  // v3 (/cart only): run, then ONE more run if the gift is due but missing or the run failed.
  const settle = async (gap) => {
    await run();
    if (lastErr || lastNeed) {
      note(lastErr ? 'cart check failed: one retry' : 'gift due but missing: one retry');
      await sleep(gap);
      await run();
    }
  };

  let timer;
  const schedule = (ms = 300) => {
    clearTimeout(timer);
    timer = setTimeout(run, ms);
  };

  const nativeFetch = window.fetch;
  window.fetch = function iboGiftFetch(input) {
    const p = nativeFetch.apply(this, arguments);
    try {
      const u = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
      if (/\/cart\/(add|change|update|clear)/.test(u) && u.indexOf(MARK) === -1) p.then(() => schedule(), () => schedule());
    } catch (e) { /* ignore */ }
    return p;
  };
  ['on:cart:add', 'on:line-item:change'].forEach((e) => d.addEventListener(e, () => schedule()));
  window.addEventListener('pageshow', (e) => { if (e.persisted) schedule(0); });
  d.addEventListener('visibilitychange', () => { if (d.visibilityState === 'visible') schedule(); });

  // Canopy replaces drawer / cart HTML with server HTML (inline scripts do not run there): repaint new progress elements.
  let paintRaf = 0;
  const onMut = () => {
    if (paintRaf) return;
    paintRaf = requestAnimationFrame(() => {
      paintRaf = 0;
      if (window.iboGiftSSR && window.iboGiftSSR.live) {
        d.querySelectorAll('[data-ibo-gift-progress]:not([data-ibo-gift-painted])').forEach((el) => window.iboGiftPaint(el));
      }
    });
  };
  if ('MutationObserver' in window && typeof window.iboGiftPaint === 'function') {
    ['cart-drawer', '#cart'].forEach((sel) => {
      const root = d.querySelector(sel);
      if (root) new MutationObserver(onMut).observe(root, { childList: true, subtree: true });
    });
  }

  // v3 (2026-10-21, task 493): /cart checkout guard. The shopper never leaves for checkout before the gift
  // check is done. Max wait 8 s; after that, checkout goes on as normal (never block a sale).
  const GUARD_MS = 8000;
  let guardBusy = false;
  const checkoutGuard = (e) => {
    const form = e.target;
    const btn = e.submitter;
    if (!form || form.id !== 'cart' || !btn || btn.name !== 'checkout') return;
    if (form.dataset.iboGiftOk === '1') { delete form.dataset.iboGiftOk; return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (guardBusy) return;
    guardBusy = true;
    btn.setAttribute('aria-busy', 'true');
    const t0 = Date.now();
    // Check until the gift is in (or not due), at most GUARD_MS (for example while another add holds the lock).
    const done = Promise.race([(async () => {
      await runP;
      await run();
      while ((lastNeed || lastErr) && Date.now() - t0 < GUARD_MS - 800) {
        await sleep(700);
        await run();
      }
    })(), sleep(GUARD_MS)]);
    done.catch(() => {}).then(async () => {
      if (pageMutated) {
        // The cart form lists the lines in the old order: send the note, then open checkout directly.
        const noteEl = form.querySelector('textarea[name="note"]') || d.querySelector('textarea[name="note"][form="cart"]');
        if (noteEl) { try { await post('cart/update.js', { note: noteEl.value }); } catch (err) { /* keep going */ } }
        note('checkout: gift checked, cart changed on this page: open /checkout');
        window.location.assign(`${base}/checkout`);
        return;
      }
      note('checkout: gift checked, no change: submit the cart form');
      guardBusy = false;
      btn.removeAttribute('aria-busy');
      form.dataset.iboGiftOk = '1';
      if (typeof form.requestSubmit === 'function') form.requestSubmit(btn);
      else {
        const h = d.createElement('input');
        h.type = 'hidden'; h.name = 'checkout'; h.value = '1';
        form.appendChild(h);
        form.submit();
      }
    });
  };

  window.iboGift = { run, config: cfg, state: load };
  if (CART_PAGE) {
    d.addEventListener('submit', checkoutGuard, true);
    settle(800);
  } else {
    schedule(0);
  }
})();
